export type ResendActivity = {
    code: CodeResendActivity,
    message: string
}

export enum CodeResendActivity {
    SUCCESS = '00'
}